enum UploadTypes {
  image = 'image',
  icon = 'icon',
  video = 'video',
  Logo = 'logo',
  Invoice = 'invoice',
  Document = 'document'
}

const PLURALIZED_ASSET_NAMES: { [key in UploadTypes]: string } = {
  image: 'images',
  icon: 'icons',
  video: 'videos',
  logo: 'logos',
  invoice: 'invoices',
  document: 'documents'
}

const FILE_MAX_SIZE: { [key in UploadTypes]: number } = {
  image: 512000,
  icon: 512000,
  video: 10485760,
  logo: 2097152,
  invoice: 10485760,
  document: 10485760
}

const FILE_MAX_SIZE_LABEL: { [key in UploadTypes]: string } = {
  image: '500 KB',
  icon: '500 KB',
  video: '10 MB',
  logo: '2 MB',
  invoice: '10 MB',
  document: '10 MB'
}

const IMAGE_UPLOAD_TOOLTIP =
  'jpg, jpeg, png, gif, mp4 files with a size less than 500kb.'
const ICON_UPLOAD_TOOLTIP =
  'jpg, jpeg, png, gif files with a size less than 500kb'
const VIDEO_UPLOAD_TOOLTIP =
  '.mp4 files with a size less than 10MB. Your video could be compressed. Please check the final video file after you save the creative.'
const MULTIPLE_UPLOAD_TOOLTIP =
  'You can upload multiple files and a creature will be created for each of them with provided settings.'

const useFileUpload = (file: any, ref: any, type: UploadTypes, errors: any) => {
  if (file.raw.size > FILE_MAX_SIZE[type]) {
    errors.value = {
      [type]: `Please upload file up to ${FILE_MAX_SIZE_LABEL[type]}`
    }
    ref.value.handleRemove(file)
    return false
  }

  errors.value = {}
  return true
}

export {
  useFileUpload,
  UploadTypes,
  IMAGE_UPLOAD_TOOLTIP,
  ICON_UPLOAD_TOOLTIP,
  VIDEO_UPLOAD_TOOLTIP,
  MULTIPLE_UPLOAD_TOOLTIP,
  PLURALIZED_ASSET_NAMES
}
